import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources'

import RedemptionScreenContainer from 'components/RedemptionScreenContainer'

export const ContentContainer = styled(RedemptionScreenContainer)`
  justify-content: space-between;
`

export const RateExpirationSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const RateExpirationText = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 36px;
  line-height: 1;
  color: ${COLOURS.neutralWhite};
`

export const RateExpirationTextRed = styled.span`
  color: ${COLOURS.secondaryRed2};
`
export const Icon = styled.img`
  height: 18px;
  width: 18px;
  margin-right: 3px;
`
export const HeroContainer = styled.div`
  width: 100%;
  background-color: ${COLOURS.black};
  color: ${COLOURS.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  position: relative;
`

export const TextSectionContainer = styled.div`
  margin-right: 0;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.md}) {
    margin-right: 250px;
  }
`

export const TitleHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const TitleHeader = styled.div`
  font-weight: bold;
  font-style: italic;
`
